
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compare/[series]",
      function () {
        return require("private-next-pages/compare/[series].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compare/[series]"])
      });
    }
  